import React from 'react';

interface EditorHeaderProps {
  content: string;
  title: string;
  coverImage: string | null;
}

const EditorHeader: React.FC<EditorHeaderProps> = ({ title }) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <h1 className="text-2xl font-bold">Text Editor</h1>
    </div>
  );
};

export default EditorHeader;